if (!customElements.get('product-upsells-bundles')) {
  customElements.define('product-upsells-bundles', class ProductBundles extends HTMLElement {
    constructor() {
      super();
      this.currentCartItems = [];
    }

    async connectedCallback() {
      if (typeof this.initBundleLogic === 'function') {
        this.initBundleLogic();
      }

      await this.updateCartData();
      this.filterItems();

      if (typeof subscribe === 'function') {
        this.unsubscribeCartUpdate = subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
          if (event?.cartData?.items) {
            this.currentCartItems = event.cartData.items;
          } else {
            await this.updateCartData();
          }
          this.filterItems();
        });
      }
    }

    async updateCartData() {
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart.js`);
        const cartData = await response.json();
        this.currentCartItems = cartData.items || [];
      } catch (error) {
        console.error('Cart fetch error:', error);
      }
    }

    filterItems() {
      const isHideSettingActive = this.getAttribute('data-hide-added') === 'true';
      const bundleElements = this.querySelectorAll('[data-bundle-product-id]');
      let visibleItemsCount = 0;

      bundleElements.forEach(bundleItem => {
        const productId = bundleItem.dataset.bundleProductId;
        const isProductAlreadyInCart = this.currentCartItems.some(
          (cartItem) => String(cartItem.product_id) === String(productId)
        );

        const shouldHideCurrentItem = isHideSettingActive && isProductAlreadyInCart;

        bundleItem.style.setProperty('--item-display', shouldHideCurrentItem ? 'none' : 'flex');

        if (shouldHideCurrentItem) {
          const bundleCheckbox = bundleItem.querySelector('[data-bundle-checkbox]');
          if (bundleCheckbox) {
            bundleCheckbox.checked = false;
          }
        } else {
          visibleItemsCount++;
        }
      });

      const sectionDisplayValue = visibleItemsCount > 0 ? 'block' : 'none';
      this.style.setProperty('--section-display', sectionDisplayValue);
      this.classList.toggle('product-upsells-bundles--empty', visibleItemsCount === 0);
    }
  });
}